export default "__VITE_ASSET__BxJwTxd4__"